import { render, staticRenderFns } from "./BaseTLTextArea.vue?vue&type=template&id=3ec938c5&"
import script from "./BaseTLTextArea.vue?vue&type=script&lang=ts&"
export * from "./BaseTLTextArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports